/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPost = /* GraphQL */ `
  query GetPost($id: ID!) {
    getPost(id: $id) {
      id
      title
      blog {
        id
        name
        author
        createdAt
        updatedAt
        owner
        __typename
      }
      comments {
        nextToken
        __typename
      }
      blogID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPosts = /* GraphQL */ `
  query ListPosts(
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        blogID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      post {
        id
        title
        blogID
        createdAt
        updatedAt
        __typename
      }
      content
      createdAt
      updatedAt
      postCommentsId
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        createdAt
        updatedAt
        postCommentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSeries = /* GraphQL */ `
  query GetSeries($id: ID!) {
    getSeries(id: $id) {
      id
      title
      description
      plot
      releaseDate
      seasons {
        nextToken
        __typename
      }
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listSeries = /* GraphQL */ `
  query ListSeries(
    $filter: ModelSeriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        plot
        releaseDate
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAlbum = /* GraphQL */ `
  query GetAlbum($id: ID!) {
    getAlbum(id: $id) {
      id
      title
      description
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listAlbums = /* GraphQL */ `
  query ListAlbums(
    $filter: ModelAlbumFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlbums(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSeason = /* GraphQL */ `
  query GetSeason($id: ID!) {
    getSeason(id: $id) {
      id
      seriesId
      title
      seasonNumber
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listSeasons = /* GraphQL */ `
  query ListSeasons(
    $filter: ModelSeasonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeasons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        seriesId
        title
        seasonNumber
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContent = /* GraphQL */ `
  query GetContent($id: ID!) {
    getContent(id: $id) {
      id
      seasonId
      season {
        id
        seriesId
        title
        seasonNumber
        createdAt
        updatedAt
        owner
        __typename
      }
      seriesId
      series {
        id
        title
        description
        plot
        releaseDate
        createdAt
        updatedAt
        owner
        __typename
      }
      albumId
      album {
        id
        title
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      agreementId
      agreement {
        id
        companyName
        emailAddress
        dateOfAgreement
        officialAddress
        designation
        paymentDueDate
        technicalName
        technicalDesignation
        technicalEmail
        technicalPhoneNumber
        billingName
        billingDesignation
        billingEmail
        billingPhoneNumber
        signingAuthorityName
        commercialName
        commercialDesignation
        commercialEmail
        commercialPhoneNumber
        currency
        milestones
        partyA
        partyB
        daysOfAgreement
        licensingRegion
        licensingCountry
        carrierType
        numberOfRefreshCycles
        airline
        amountPaid
        amountRemaining
        numberOfMonthsPerCycle
        contractValue
        paymentStatus
        paymentPlan
        paymentTerm
        paymentModel
        paymentReceiptFilePath
        agreementFilePath
        createdAt
        updatedAt
        owner
        __typename
      }
      status
      title
      type
      category
      director
      actors
      duration
      releaseDate
      synopsis
      language
      filePath
      masterSubtitleFilePath
      trailerFilePath
      trailerSubtitleFilePath
      artist
      composer
      imdbRating
      rottenRating
      rating
      studios
      country
      year
      posters
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isGrouped
      isAlbum
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      isOneDrive
      sequence
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      currentCycle
      feedbacks {
        items {
          id
          contentId
          overallComment
          timestamps {
            items {
              id
              feedbackId
              type
              fromTime
              toTime
              comment
              createdAt
              updatedAt
              owner
              __typename
            }
          }
          createdAt
          updatedAt
          adminId
          __typename
        }
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listContents = /* GraphQL */ `
  query ListContents(
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        seasonId
        season {
          id
          seriesId
          title
          seasonNumber
          contents {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        seriesId
        albumId
        agreementId
        agreement {
          id
          companyName
          dateOfAgreement
          paymentDueDate
          currency
          daysOfAgreement
          licensingRegion
          licensingCountry
          carrierType
          numberOfRefreshCycles
          airline
          amountPaid
          amountRemaining
          numberOfMonthsPerCycle
          contractValue
          paymentStatus
          paymentPlan
          paymentTerm
          paymentReceiptFilePath
          agreementFilePath
          contents {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          owner
          __typename
        }
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      contentId
      content {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      overallComment
      timestamps {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      adminId
      __typename
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        contentId
        overallComment
        createdAt
        updatedAt
        adminId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTimestamp = /* GraphQL */ `
  query GetTimestamp($id: ID!) {
    getTimestamp(id: $id) {
      id
      feedbackId
      type
      feedback {
        id
        contentId
        overallComment
        createdAt
        updatedAt
        adminId
        __typename
      }
      fromTime
      toTime
      comment
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listTimestamps = /* GraphQL */ `
  query ListTimestamps(
    $filter: ModelTimestampFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimestamps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        feedbackId
        type
        fromTime
        toTime
        comment
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgreement = /* GraphQL */ `
  query GetAgreement($id: ID!) {
    getAgreement(id: $id) {
      id
      companyName
      emailAddress
      dateOfAgreement
      officialAddress
      designation
      paymentDueDate
      technicalName
      technicalDesignation
      technicalEmail
      technicalPhoneNumber
      billingName
      billingDesignation
      billingEmail
      billingPhoneNumber
      signingAuthorityName
      commercialName
      commercialDesignation
      commercialEmail
      commercialPhoneNumber
      currency
      milestones
      partyA
      partyB
      daysOfAgreement
      licensingRegion
      licensingCountry
      carrierType
      numberOfRefreshCycles
      airline
      amountPaid
      amountRemaining
      numberOfMonthsPerCycle
      contractValue
      paymentStatus
      paymentPlan
      paymentTerm
      paymentModel
      paymentReceiptFilePath
      agreementFilePath
      contents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listAgreements = /* GraphQL */ `
  query ListAgreements(
    $filter: ModelAgreementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgreements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyName
        emailAddress
        dateOfAgreement
        officialAddress
        designation
        paymentDueDate
        technicalName
        technicalDesignation
        technicalEmail
        technicalPhoneNumber
        billingName
        billingDesignation
        billingEmail
        billingPhoneNumber
        signingAuthorityName
        commercialName
        commercialDesignation
        commercialEmail
        commercialPhoneNumber
        currency
        milestones
        partyA
        partyB
        daysOfAgreement
        licensingRegion
        licensingCountry
        carrierType
        numberOfRefreshCycles
        airline
        amountPaid
        amountRemaining
        numberOfMonthsPerCycle
        contractValue
        paymentStatus
        paymentPlan
        paymentTerm
        paymentModel
        paymentReceiptFilePath
        agreementFilePath
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPaymentDetails = /* GraphQL */ `
  query GetPaymentDetails($id: ID!) {
    getPaymentDetails(id: $id) {
      id
      accountName
      IBANNumber
      bankName
      contractValue
      companyName
      swiftCode
      currency
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPaymentDetails = /* GraphQL */ `
  query ListPaymentDetails(
    $filter: ModelPaymentDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountName
        IBANNumber
        bankName
        contractValue
        companyName
        swiftCode
        currency
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const postsByBlogID = /* GraphQL */ `
  query PostsByBlogID(
    $blogID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postsByBlogID(
      blogID: $blogID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        blogID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const seasonsBySeriesId = /* GraphQL */ `
  query SeasonsBySeriesId(
    $seriesId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSeasonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    seasonsBySeriesId(
      seriesId: $seriesId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seriesId
        title
        seasonNumber
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const contentsBySeasonId = /* GraphQL */ `
  query ContentsBySeasonId(
    $seasonId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contentsBySeasonId(
      seasonId: $seasonId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const contentsBySeriesId = /* GraphQL */ `
  query ContentsBySeriesId(
    $seriesId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contentsBySeriesId(
      seriesId: $seriesId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const contentsByAlbumId = /* GraphQL */ `
  query ContentsByAlbumId(
    $albumId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contentsByAlbumId(
      albumId: $albumId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const contentsByAgreementId = /* GraphQL */ `
  query ContentsByAgreementId(
    $agreementId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contentsByAgreementId(
      agreementId: $agreementId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        seasonId
        seriesId
        albumId
        agreementId
        status
        title
        type
        category
        director
        actors
        duration
        releaseDate
        synopsis
        language
        filePath
        masterSubtitleFilePath
        trailerFilePath
        trailerSubtitleFilePath
        artist
        composer
        imdbRating
        rottenRating
        rating
        studios
        country
        year
        posters
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isGrouped
        isAlbum
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        isOneDrive
        sequence
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        currentCycle
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedbacksByContentId = /* GraphQL */ `
  query FeedbacksByContentId(
    $contentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedbacksByContentId(
      contentId: $contentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contentId
        overallComment
        createdAt
        updatedAt
        adminId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timestampsByFeedbackId = /* GraphQL */ `
  query TimestampsByFeedbackId(
    $feedbackId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTimestampFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timestampsByFeedbackId(
      feedbackId: $feedbackId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        feedbackId
        type
        fromTime
        toTime
        comment
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlog = /* GraphQL */ `
  query GetBlog($id: ID!) {
    getBlog(id: $id) {
      id
      name
      author
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listBlogs = /* GraphQL */ `
  query ListBlogs(
    $filter: ModelBlogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        author
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      title
      type
      isActive
      Genres {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCategories = /* GraphQL */ `
  query ListCategories(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGenre = /* GraphQL */ `
  query GetGenre($id: ID!) {
    getGenre(id: $id) {
      id
      title
      isActive
      categoryID
      category {
        id
        title
        type
        isActive
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGenres = /* GraphQL */ `
  query ListGenres(
    $filter: ModelGenreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGenres(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        isActive
        categoryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const genresByCategoryID = /* GraphQL */ `
  query GenresByCategoryID(
    $categoryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGenreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    genresByCategoryID(
      categoryID: $categoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        isActive
        categoryID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVideoContent = /* GraphQL */ `
  query GetVideoContent($id: ID!) {
    getVideoContent(id: $id) {
      id
      contentPath
      poster
      category
      title
      year
      rated
      released
      runtime
      genre
      director
      actors
      plot
      imdbRating
      tomatoMeter
      fileId
      tomatoRating
      onlyDeployMetaData
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVideoContents = /* GraphQL */ `
  query ListVideoContents(
    $filter: ModelVideoContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        contentPath
        poster
        category
        title
        year
        rated
        released
        runtime
        genre
        director
        actors
        plot
        imdbRating
        tomatoMeter
        fileId
        tomatoRating
        onlyDeployMetaData
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGame = /* GraphQL */ `
  query GetGame($id: ID!) {
    getGame(id: $id) {
      id
      providerId
      title
      year
      developer
      description
      howToPlay
      poster
      contentType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGames = /* GraphQL */ `
  query ListGames(
    $filter: ModelGameFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGames(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        providerId
        title
        year
        developer
        description
        howToPlay
        poster
        contentType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLanguage = /* GraphQL */ `
  query GetLanguage($id: ID!) {
    getLanguage(id: $id) {
      id
      name
      nativeName
      code
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLanguages = /* GraphQL */ `
  query ListLanguages(
    $filter: ModelLanguageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLanguages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        nativeName
        code
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProvider = /* GraphQL */ `
  query GetProvider($id: ID!) {
    getProvider(id: $id) {
      id
      name
      isActive
      contentType
      contentCategory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProviders = /* GraphQL */ `
  query ListProviders(
    $filter: ModelProviderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        isActive
        contentType
        contentCategory
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPointOfInterest = /* GraphQL */ `
  query GetPointOfInterest($id: ID!) {
    getPointOfInterest(id: $id) {
      id
      name
      languageKey
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPointOfInterests = /* GraphQL */ `
  query ListPointOfInterests(
    $filter: ModelPointOfInterestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPointOfInterests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        languageKey
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMediaItem = /* GraphQL */ `
  query GetMediaItem($id: ID!) {
    getMediaItem(id: $id) {
      id
      carrierId
      category
      drmCount
      minCount
      maxCount
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMediaItems = /* GraphQL */ `
  query ListMediaItems(
    $filter: ModelMediaItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMediaItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        carrierId
        category
        drmCount
        minCount
        maxCount
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCarrier = /* GraphQL */ `
  query GetCarrier($id: ID!) {
    getCarrier(id: $id) {
      id
      carrierName
      bukcet
      iataode
      contractType
      emailAddress
      isActive
      Manifests {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCarriers = /* GraphQL */ `
  query ListCarriers(
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        carrierName
        bukcet
        iataode
        contractType
        emailAddress
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getManifest = /* GraphQL */ `
  query GetManifest($id: ID!) {
    getManifest(id: $id) {
      id
      title
      carrierId
      carrier {
        id
        carrierName
        bukcet
        iataode
        contractType
        emailAddress
        isActive
        createdAt
        updatedAt
        __typename
      }
      adminApproved
      carrierApproved
      adminComments
      carrierComments
      manifestDate
      contentStartDate
      contentEndDate
      isActive
      isManifestDeployed
      DeploymentDate
      bucket
      date
      ManifestItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listManifests = /* GraphQL */ `
  query ListManifests(
    $filter: ModelManifestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listManifests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        carrierId
        adminApproved
        carrierApproved
        adminComments
        carrierComments
        manifestDate
        contentStartDate
        contentEndDate
        isActive
        isManifestDeployed
        DeploymentDate
        bucket
        date
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const manifestsByCarrierId = /* GraphQL */ `
  query ManifestsByCarrierId(
    $carrierId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelManifestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    manifestsByCarrierId(
      carrierId: $carrierId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        carrierId
        adminApproved
        carrierApproved
        adminComments
        carrierComments
        manifestDate
        contentStartDate
        contentEndDate
        isActive
        isManifestDeployed
        DeploymentDate
        bucket
        date
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getManifestItem = /* GraphQL */ `
  query GetManifestItem($id: ID!) {
    getManifestItem(id: $id) {
      id
      providerId
      isActive
      manifestID
      contentId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listManifestItems = /* GraphQL */ `
  query ListManifestItems(
    $filter: ModelManifestItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listManifestItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        providerId
        isActive
        manifestID
        contentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const manifestItemsByManifestID = /* GraphQL */ `
  query ManifestItemsByManifestID(
    $manifestID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelManifestItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    manifestItemsByManifestID(
      manifestID: $manifestID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        providerId
        isActive
        manifestID
        contentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEntertainment = /* GraphQL */ `
  query GetEntertainment($id: ID!) {
    getEntertainment(id: $id) {
      id
      actors
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      website
      writer
      year
      contentType
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEntertainments = /* GraphQL */ `
  query ListEntertainments(
    $filter: ModelEntertainmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEntertainments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        actors
        awards
        boxOffice
        country
        director
        dvd
        genre
        imdbId
        imdbRating
        imdbVotes
        language
        metaScore
        plot
        poster
        production
        rated
        released
        runtime
        title
        rottenTomatoConsensus
        rottenTomatoFresh
        rottenTomatoImage
        rottenTomatoMeter
        rottenTomatoRating
        rottenTomatoReviews
        rottenTomatoRotten
        rottenTomatoUrl
        rottenTomatoUserMeter
        rottenTomatoUserRating
        rottenTomatoUserReviews
        type
        website
        writer
        year
        contentType
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCity = /* GraphQL */ `
  query GetCity($id: ID!) {
    getCity(id: $id) {
      id
      countryId
      name
      nativeName
      picture
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCities = /* GraphQL */ `
  query ListCities(
    $filter: ModelCityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        countryId
        name
        nativeName
        picture
        summary
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOneDriveContent = /* GraphQL */ `
  query GetOneDriveContent($id: ID!) {
    getOneDriveContent(id: $id) {
      id
      files {
        filePath
        downloadUrl
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOneDriveContents = /* GraphQL */ `
  query ListOneDriveContents(
    $filter: ModelOneDriveContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOneDriveContents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNewContent = /* GraphQL */ `
  query GetNewContent($id: ID!) {
    getNewContent(id: $id) {
      id
      title
      type
      category
      director
      actors
      duration
      releaseDate
      description
      language
      filePath
      rating
      studio
      country
      year
      posters
      licensingInfo
      fileSize
      creators
      author
      genre
      publisher
      publicationYear
      isSeries
      isDrmProtected
      isDrmEncodedSuccessfully
      axinomDrmEncodingJobId
      encodedFilePath
      encodedFolderPath
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNewContents = /* GraphQL */ `
  query ListNewContents(
    $filter: ModelNewContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        type
        category
        director
        actors
        duration
        releaseDate
        description
        language
        filePath
        rating
        studio
        country
        year
        posters
        licensingInfo
        fileSize
        creators
        author
        genre
        publisher
        publicationYear
        isSeries
        isDrmProtected
        isDrmEncodedSuccessfully
        axinomDrmEncodingJobId
        encodedFilePath
        encodedFolderPath
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCountry = /* GraphQL */ `
  query GetCountry($id: ID!) {
    getCountry(id: $id) {
      id
      name
      nativeName
      code
      summary
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCountries = /* GraphQL */ `
  query ListCountries(
    $filter: ModelCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCountries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        nativeName
        code
        summary
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDestination = /* GraphQL */ `
  query GetDestination($id: ID!) {
    getDestination(id: $id) {
      id
      languageId
      countryId
      cityId
      pointOfInterestId
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDestinations = /* GraphQL */ `
  query ListDestinations(
    $filter: ModelDestinationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDestinations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        languageId
        countryId
        cityId
        pointOfInterestId
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDestinationItem = /* GraphQL */ `
  query GetDestinationItem($id: ID!) {
    getDestinationItem(id: $id) {
      id
      destinationId
      pointOfInterestId
      carrierId
      bucket
      iataCode
      title
      summary
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDestinationItems = /* GraphQL */ `
  query ListDestinationItems(
    $filter: ModelDestinationItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDestinationItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        destinationId
        pointOfInterestId
        carrierId
        bucket
        iataCode
        title
        summary
        picture
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDestinationItemCategory = /* GraphQL */ `
  query GetDestinationItemCategory($id: ID!) {
    getDestinationItemCategory(id: $id) {
      id
      destinationId
      destinationItemId
      title
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDestinationItemCategories = /* GraphQL */ `
  query ListDestinationItemCategories(
    $filter: ModelDestinationItemCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDestinationItemCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        destinationId
        destinationItemId
        title
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDestinationItemCategorySubitem = /* GraphQL */ `
  query GetDestinationItemCategorySubitem($id: ID!) {
    getDestinationItemCategorySubitem(id: $id) {
      id
      destinationItemId
      destinationItemCategoryId
      title
      details
      picture
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDestinationItemCategorySubitems = /* GraphQL */ `
  query ListDestinationItemCategorySubitems(
    $filter: ModelDestinationItemCategorySubitemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDestinationItemCategorySubitems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        destinationItemId
        destinationItemCategoryId
        title
        details
        picture
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSearchContent = /* GraphQL */ `
  query GetSearchContent($id: ID!) {
    getSearchContent(id: $id) {
      id
      providerId
      actors
      album
      awards
      boxOffice
      country
      director
      dvd
      genre
      imdbId
      imdbRating
      imdbVotes
      language
      metaScore
      plot
      poster
      production
      rated
      released
      runtime
      title
      titleAsBase64
      rottenTomatoConsensus
      rottenTomatoFresh
      rottenTomatoImage
      rottenTomatoMeter
      rottenTomatoRating
      rottenTomatoReviews
      rottenTomatoRotten
      rottenTomatoUrl
      rottenTomatoUserMeter
      rottenTomatoUserRating
      rottenTomatoUserReviews
      type
      category
      trailer
      website
      writer
      year
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSearchContents = /* GraphQL */ `
  query ListSearchContents(
    $filter: ModelSearchContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSearchContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        providerId
        actors
        album
        awards
        boxOffice
        country
        director
        dvd
        genre
        imdbId
        imdbRating
        imdbVotes
        language
        metaScore
        plot
        poster
        production
        rated
        released
        runtime
        title
        titleAsBase64
        rottenTomatoConsensus
        rottenTomatoFresh
        rottenTomatoImage
        rottenTomatoMeter
        rottenTomatoRating
        rottenTomatoReviews
        rottenTomatoRotten
        rottenTomatoUrl
        rottenTomatoUserMeter
        rottenTomatoUserRating
        rottenTomatoUserReviews
        type
        category
        trailer
        website
        writer
        year
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdvertiser = /* GraphQL */ `
  query GetAdvertiser($id: ID!) {
    getAdvertiser(id: $id) {
      id
      name
      email
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdvertisers = /* GraphQL */ `
  query ListAdvertisers(
    $filter: ModelAdvertiserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdvertisers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      startDate
      endDate
      budget
      totalDurationOfAds
      estimatedCostOfCampaign
      approvedCostOfCampaign
      status
      paid
      keywords
      adverts {
        nextToken
        __typename
      }
      banktransfers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdvert = /* GraphQL */ `
  query GetAdvert($id: ID!) {
    getAdvert(id: $id) {
      id
      title
      type
      keywords
      filePath
      duration
      status
      campaigns {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdverts = /* GraphQL */ `
  query ListAdverts(
    $filter: ModelAdvertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdverts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        type
        keywords
        filePath
        duration
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCampaignAdvertInventory = /* GraphQL */ `
  query GetCampaignAdvertInventory($id: ID!) {
    getCampaignAdvertInventory(id: $id) {
      id
      advertId
      advert {
        id
        title
        type
        keywords
        filePath
        duration
        status
        createdAt
        updatedAt
        __typename
      }
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      preRollIsSkippable
      preRollSkipAfter
      preRollDuration
      midRollIsSkippable
      midRollSkipAfter
      midRollDuration
      postRollIsSkippable
      postRollSkipAfter
      postRollDuration
      requestStatus
      requestDeclineReason
      totalDuration
      totalCost
      paid
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCampaignAdvertInventories = /* GraphQL */ `
  query ListCampaignAdvertInventories(
    $filter: ModelCampaignAdvertInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaignAdvertInventories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        advertId
        campaignId
        preRollIsSkippable
        preRollSkipAfter
        preRollDuration
        midRollIsSkippable
        midRollSkipAfter
        midRollDuration
        postRollIsSkippable
        postRollSkipAfter
        postRollDuration
        requestStatus
        requestDeclineReason
        totalDuration
        totalCost
        paid
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const campaignAdvertInventoriesByAdvertId = /* GraphQL */ `
  query CampaignAdvertInventoriesByAdvertId(
    $advertId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignAdvertInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    campaignAdvertInventoriesByAdvertId(
      advertId: $advertId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        advertId
        campaignId
        preRollIsSkippable
        preRollSkipAfter
        preRollDuration
        midRollIsSkippable
        midRollSkipAfter
        midRollDuration
        postRollIsSkippable
        postRollSkipAfter
        postRollDuration
        requestStatus
        requestDeclineReason
        totalDuration
        totalCost
        paid
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const campaignAdvertInventoriesByCampaignId = /* GraphQL */ `
  query CampaignAdvertInventoriesByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignAdvertInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    campaignAdvertInventoriesByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        advertId
        campaignId
        preRollIsSkippable
        preRollSkipAfter
        preRollDuration
        midRollIsSkippable
        midRollSkipAfter
        midRollDuration
        postRollIsSkippable
        postRollSkipAfter
        postRollDuration
        requestStatus
        requestDeclineReason
        totalDuration
        totalCost
        paid
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdDetail = /* GraphQL */ `
  query GetAdDetail($id: ID!) {
    getAdDetail(id: $id) {
      id
      playOrder
      numberOfAds
      minutesOfAds
      isSkippable
      pricing
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdDetails = /* GraphQL */ `
  query ListAdDetails(
    $filter: ModelAdDetailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        playOrder
        numberOfAds
        minutesOfAds
        isSkippable
        pricing
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      orderType
      linkedId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderType
        linkedId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBank = /* GraphQL */ `
  query GetBank($id: ID!) {
    getBank(id: $id) {
      id
      bankName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBanks = /* GraphQL */ `
  query ListBanks(
    $filter: ModelBankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBanks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        bankName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      fullName
      companyName
      emailAddress
      designation
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fullName
        companyName
        emailAddress
        designation
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCloudAccount = /* GraphQL */ `
  query GetCloudAccount($id: ID!) {
    getCloudAccount(id: $id) {
      id
      account
      refreshToken
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCloudAccounts = /* GraphQL */ `
  query ListCloudAccounts(
    $filter: ModelCloudAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCloudAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        account
        refreshToken
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserBankAccount = /* GraphQL */ `
  query GetUserBankAccount($id: ID!) {
    getUserBankAccount(id: $id) {
      id
      bankName
      accountTitle
      accountNumber
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserBankAccounts = /* GraphQL */ `
  query ListUserBankAccounts(
    $filter: ModelUserBankAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserBankAccounts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        bankName
        accountTitle
        accountNumber
        isActive
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBankTransfer = /* GraphQL */ `
  query GetBankTransfer($id: ID!) {
    getBankTransfer(id: $id) {
      id
      amount
      accountHolderName
      accountNumber
      bankName
      type
      receiptUrl
      reference
      paymentStatus
      campaignId
      campaign {
        id
        name
        startDate
        endDate
        budget
        totalDurationOfAds
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        keywords
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBankTransfers = /* GraphQL */ `
  query ListBankTransfers(
    $filter: ModelBankTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBankTransfers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        amount
        accountHolderName
        accountNumber
        bankName
        type
        receiptUrl
        reference
        paymentStatus
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bankTransfersByCampaignId = /* GraphQL */ `
  query BankTransfersByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBankTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bankTransfersByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        amount
        accountHolderName
        accountNumber
        bankName
        type
        receiptUrl
        reference
        paymentStatus
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
